import mamaShrimpTomYum from '../../assets/images/noodles/mamaShrimpTomYum.png';
import mamaCreamyShrimp from '../../assets/images/noodles/mamaCreamyShrimp.png';
import mamaPork from '../../assets/images/noodles/mamaPork.png';
import mamaDuck from '../../assets/images/noodles/mamaDuck.png';
import mamaChicken from '../../assets/images/noodles/mamaChicken.png';
import mamaBeef from '../../assets/images/noodles/mamaBeef.png';
import mamaSpicyPork from '../../assets/images/noodles/mamaSpicyPork.png';
import mamaSpicy from '../../assets/images/noodles/mamaSpicy.png';
import mamaPhoBo from '../../assets/images/noodles/mamaPhoBo.png';
import mamaPhoGo from '../../assets/images/noodles/mamaPhoGo.png';
import mamaChand from '../../assets/images/noodles/mamaChand.png';
import mamaPadThai from '../../assets/images/noodles/mamaPadThai.png';
import indomieOriginal from '../../assets/images/noodles/indomieOriginal.png';
import indomieHotSpicy from '../../assets/images/noodles/indomieHotSpicy.png';
import indomieOnionChicken from '../../assets/images/noodles/indomieOnionChicken.png';
import myojoUdonBeef from '../../assets/images/noodles/myojoUdonBeef.png';
import myojoChicken from '../../assets/images/noodles/myojoChicken.png';
import myojoOriginal from '../../assets/images/noodles/myojoOriginal.png';
import myojoHot from '../../assets/images/noodles/myojoHot.png';
import myojoShrimp from '../../assets/images/noodles/myojoShrimp.png';
import myojoMushroom from '../../assets/images/noodles/myojoMushroom.png';
import demaeChicken from '../../assets/images/noodles/demaeChicken.png';
import demaeSesame from '../../assets/images/noodles/demaeSesame.png';
import demaeShoyu from '../../assets/images/noodles/demaeShoyu.png';
import demaeTonkotsu from '../../assets/images/noodles/demaeTonkotsu.png';
import demaeSeafood from '../../assets/images/noodles/demaeSeafood.png';

import buldakCurry from '../../assets/images/noodles/buldakCurry.png';
import buldakJjamppong from '../../assets/images/noodles/buldakJjamppong.png';

// flag images
import china from '../../assets/images/flags/china.png';
import korea from '../../assets/images/flags/korea.png';
import indonesia from '../../assets/images/flags/indonesia.png';
import hongKong from '../../assets/images/flags/hongKong.png';
import thailand from '../../assets/images/flags/thailand.png';
import us from '../../assets/images/flags/us.png';
import japan from '../../assets/images/flags/japan.png';
import taiwan from '../../assets/images/flags/taiwan.png';
// import vietnam from '../../assets/images/flags/vietnam.png';
import singapore from '../../assets/images/flags/singapore.png';
import india from '../../assets/images/flags/india.png';

const noodles = [
    {
      number: 0,
      name: "MAMA Shrimp Tom Yum",
      price: 3.5,
      href: mamaShrimpTomYum,
      priceColor: "red",
      description: "Shrimpy Tom Yum soup with thin noodles",
      tips: ["spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 2,
      mobileWidth: 70,
      mobileHeight: 85,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      beef: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 1,
      name: "MAMA Creamy Tom Yum",
      price: 3.5,
      href: mamaCreamyShrimp,
      priceColor: "red",
      description: "Creamier Tom Yum soup with thin noodles",
      tips: ["spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 2,
      mobileWidth: 70,
      mobileHeight: 85,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 2,
      name: "MAMA Pork",
      price: 3.5,
      href: mamaPork,
      priceColor: "red",
      description: "Smoky and sweet pork flavor with a tiny spice kick (optional to add in the spice packet!)",
      tips: ["spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 2,
      mobileWidth: 70,
      mobileHeight: 85,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 3,
      name: "MAMA Palo Duck",
      price: 3.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: mamaDuck,
      priceColor: "red",
      description: "Deeply flavorful duck broth with a thin, springy noodle",
      tips: ["if you ever have leftover cooked duck meat, add it into this soup when you start cooking the noodle for an excellent meal", "spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 2,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 4,
      name: "MAMA Chicken",
      price: 3.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: mamaChicken,
      priceColor: "red",
      description: "Chicken/garlic oil broth with thin noodles",
      tips: ["spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 2,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 5,
      name: "MAMA Stew Beef",
      price: 3.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: mamaBeef,
      priceColor: "red",
      description: "Stewed beef, slightly spicy broth with thin noodles",
      tips: ["spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 2,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      beef: 1,
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 6,
      name: "MAMA Moo Nam Tok Pork",
      price: 3.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: mamaSpicyPork,
      priceColor: "red",
      description: "Inspired by Moo Nam Tok - pork, onions, mint",
      tips: ["spice packet is seperate from the rest of the flavor packet - avoid adding it to skip the spice!"],
      spice: 3,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 7,
      name: "MAMA Tom Saab",
      price: 3.5,
      mobileWidth: 68,
      mobileHeight: 85,
      href: mamaSpicy,
      priceColor: "red",
      description: "Thai hot and sour soup with pork, limes, and chili",
      tips: [],
      spice: 4,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 8,
      name: "MAMA Pho Bo",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 70,
      href: mamaPhoBo,
      priceColor: "red",
      description: "Classic pho flavors with a thin, chewy rice noodle",
      tips: ["perfect snack size, make it a double noodle for a standard portion of pho!"],
      spice: 1,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 9,
      name: "MAMA Pho Go",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 70,
      href: mamaPhoGo,
      priceColor: "red",
      description: "Classic chicken pho flavors with a thin, chewy rice noodle",
      tips: ["perfect snack size, make it a double noodle for a standard portion of pho!"],
      spice: 1,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      beef: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 10,
      name: "MAMA Clear Chand",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 70,
      href: mamaChand,
      priceColor: "red",
      description: "Clear, light broth with a thicker, chewy rice noodle",
      tips: ["perfect snack size, make it a double noodle for a standard portion of pho!"],
      spice: 1,
      country: thailand,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 11,
      name: "MAMA Pad Thai",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 70,
      href: mamaPadThai,
      priceColor: "red",
      description:
        "Classic pad thai stir fry noodle - sweet savory and sour at the same time with peanuty notes",
      tips: ["make sure not to overcook this noodle - keep it a bit undercooked"],
      spice: 1,
      country: thailand,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 12,
      name: "Indomie - Regular",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 75,
      href: indomieOriginal,
      priceColor: "red",
      description: "Soy stir-fried noodles famous in Southeast Asia",
      tips: ["use a pan to stir fry your cooked noodles the sauce, then use the same pan to fry an egg for the perfect side"],
      spice: "",
      country: indonesia,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 13,
      name: "Indomie - Hot and Spicy",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 75,
      href: indomieHotSpicy,
      priceColor: "red",
      description: "Indomie with a slightly spicier sauce",
      tips: ["use a pan to stir fry your cooked noodles the sauce, then use the same pan to fry an egg for the perfect side"],
      spice: 2,
      country: indonesia,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 14,
      name: "Indomie - Barbecue Chicken",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 75,
      href: "https://live.staticflickr.com/65535/54251218853_80a23f2517_o.png",
      priceColor: "red",
      description: "Indomie with a bbq chicken flavor",
      tips: [],
      spice: 2,
      country: indonesia,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 0,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 15,
      name: "Indomie - Special Chicken",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 75,
      href: "https://live.staticflickr.com/65535/54251218843_a854cd91ea_o.png",
      priceColor: "red",
      description: "Indomie soup - special chicken",
      tips: [],
      spice: 0,
      country: indonesia,
      stirfry: 0,
      tonkotsu: "",
      cheese: "",
      spicy: 0,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: 1,
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 16,
      name: "Indomie - Curry Chicken",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 75,
      href: "https://live.staticflickr.com/65535/54251235109_554c6c0661_o.png",
      priceColor: "red",
      description: "Indomie soup with a curry chicken flavor",
      tips: [],
      spice: 0,
      country: indonesia,
      stirfry: 0,
      tonkotsu: "",
      cheese: "",
      spicy: 0,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 17,
      name: "Indomie - Onion Chicken",
      price: 3.5,
      mobileWidth: 90,
      mobileHeight: 75,
      href: indomieOnionChicken,
      priceColor: "red",
      description: "Indomie soup with an onion chicken flavor",
      tips: [],
      spice: 0,
      country: indonesia,
      stirfry: 0,
      tonkotsu: "",
      cheese: "",
      spicy: 0,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: 1,
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 18,
      name: "Demae Chicken",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: demaeChicken,
      priceColor: "black",
      description: "Curly noodles with a chicken broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 19,
      name: "Demae Beef",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: "https://live.staticflickr.com/65535/54251014186_a3fb3d697d_o.png",
      priceColor: "black",
      description: "Curly noodles with a beef broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 20,
      name: "Demae Seafood",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: demaeSeafood,
      priceColor: "black",
      description: "Curly noodles with a seafood broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      beef: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 21,
      name: "Demae Original",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: demaeSesame,
      priceColor: "black",
      description: "Curly instant noodles, sesame oil broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 22,
      name: "Demae Tonkotsu",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: demaeTonkotsu,
      priceColor: "black",
      description: "Curly noodles with a creamy tonkotsu broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 23,
      name: "Demae Shoyu Tonkotsu",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: demaeShoyu,
      priceColor: "black",
      description: "Curly noodles with a shoyu tonkotsu broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 24,
      name: "Demae Black Garlic Shoyu Tonkotsu",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: "https://live.staticflickr.com/65535/54251252343_7655c21cb3_o.png",
      priceColor: "black",
      description:
        "Curly noodles with a shoyu tonkotsu broth, with an added black garlic punch",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 25,
      name: "Demae Miso Tonkotsu",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 75,
      href: "https://live.staticflickr.com/65535/54264802044_e19736f13c_o.png",
      priceColor: "black",
      description: "Curly noodles with a miso tonkotsu broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: 1,
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 26,
      name: "Myojo Udon Beef",
      price: 4.5,
      mobileWidth: 115,
      mobileHeight: 95,
      href: myojoUdonBeef,
      priceColor: "black",
      description: "Thick udon in a heartier beef broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 27,
      name: "Myojo Udon Mushroom",
      price: 4.5,
      mobileWidth: 115,
      mobileHeight: 95,
      href: myojoMushroom,
      priceColor: "black",
      description: "Thick udon in a veggie umami mushroom broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: 1,
      seafood: "",
      chicken: "",
      beef: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 28,
      name: "Myojo Udon Hot and Spicy",
      price: 4.5,
      mobileWidth: 115,
      mobileHeight: 95,
      href: myojoHot,
      priceColor: "black",
      description: "Thick udon in a hot and spicy broth",
      tips: [],
      spice: 3,
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 29,
      name: "Myojo Udon Chicken",
      price: 4.5,
      mobileWidth: 115,
      mobileHeight: 95,
      href: myojoChicken,
      priceColor: "black",
      description: "Thick udon in a clear chicken broth with vinegar",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 30,
      name: "Myojo Udon Shrimp",
      price: 4.5,
      mobileWidth: 115,
      mobileHeight: 95,
      href: myojoShrimp,
      priceColor: "black",
      description: "Thick udon in a light shrimp broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 31,
      name: "Myojo Udon Original",
      price: 4.5,
      mobileWidth: 115,
      mobileHeight: 95,
      href: myojoOriginal,
      priceColor: "black",
      description: "Thick udon in a clear soy broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 32,
      name: "Sapporo Ichiban Soy",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54263680987_802c438a60_o.png",
      priceColor: "black",
      description: "Soy sauce chicken broth with a hint of ginger",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 33,
      name: "Sapporo Ichiban Chicken",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54263680967_8fb711e368_o.png",
      priceColor: "black",
      description: "Light flavorful chicken and leek broth",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 34,
      name: "Sapporo Ichiban Beef",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54264793188_a6cd246b97_o.png",
      priceColor: "black",
      description: "Savory beef broth with soy, onion, spices",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 35,
      name: "Sapporo Ichiban Shrimp",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270164965_1bef261835_o.png",
      priceColor: "black",
      description: "Savory shrimp broth with the iconic, thin sapporo noodles",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      beef: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 36,
      name: "Sapporo Ichiban Miso",
      price: 4.5,
      mobileWidth: 95,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54263680947_48e8c7363a_o.png",
      priceColor: "black",
      description: "Sapporo's six-miso blend with spices",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: 1,
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 37,
      name: "Sapporo Ichiban Shio",
      price: 4.5,
      mobileWidth: 95,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54264978915_4ce77569bc_o.png",
      priceColor: "black",
      description: "Delicate clear broth flavored with salt",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 38,
      name: "Sapporo Ichiban Tonkotsu",
      price: 4.5,
      mobileWidth: 95,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54264978925_2857ed2052_o.png",
      priceColor: "black",
      description: "Rich tonkotsu broth, wavy noodles",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
  
    {
      number: 39,
      name: "Sapporo Chow Mein Yakisoba",
      price: 4.5,
      mobileWidth: 95,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54264978910_f184b478d9_o.png",
      priceColor: "black",
      description: "Yakisoba with worchestershire blend sauce",
      tips: [],
      spice: "",
      country: japan,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 40,
      name: "Sapporo Sriracha Yakisoba",
      price: 4.5,
      mobileWidth: 95,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54269744076_b3e2a22da4_o.png",
      priceColor: "black",
      description: "This classic Sapporo thin stir fry noodle features real sriracha hot sauce for a light, constant heat",
      tips: [],
      spice: 3,
      country: japan,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 41,
      name: "Sautao Lobster Thick Noodles",
      price: 4.5,
      mobileWidth: 95,
      mobileHeight: 100,
      href: "https://live.staticflickr.com/65535/54270219340_e9a0f06a80_o.png",
      priceColor: "black",
      description: "Lobster-flavored broth with HK-style flat egg noodles",
      tips: [],
      spice: "",
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 42,
      name: "Higashimaru Kagoshima",
      price: 4.5,
      mobileWidth: 85,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54270042544_8e3f618f19_o.png",
      priceColor: "black",
      description: "Classic rich tonkotsu, thin noodles",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 43,
      name: "Higashimaru Spicy Tonkotsu",
      price: 4.5,
      mobileWidth: 85,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54270039813_761a64b247_o.png",
      priceColor: "black",
      description: "Spicy tonkotsu with thin noodles",
      tips: [],
      spice: 2,
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 44,
      name: "Hwa Ramyun",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54269797836_47b2ece8fe_o.png",
      priceColor: "black",
      description: "A classic spicy beef broth",
      tips: [],
      spice: 4,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 45,
      name: "Gomtang",
      price: 4,
      mobileWidth: 95,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54270042509_3dbcb050cb_o.png",
      priceColor: "black",
      description: "Famous beef bone noodles with a deep, creamy broth",
      tips: [],
      spice: "",
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 46,
      name: "BulJjamppong",
      price: 4,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270219235_0532261f20_o.png",
      priceColor: "black",
      description: "Spicy classic korean seafood stew",
      tips: [],
      spice: 4,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 47,
      name: "Nissin Cup Japan - Original",
      price: 6.5,
      mobileWidth: 80,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54268914917_8a2d0a49dc_o.png",
      priceColor: "beige",
      description: "Classic original noodle with flakes",
      tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 48,
      name: "Nissin Cup HK - Spicy Beef",
      price: 5.5,
      mobileWidth: 80,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54268914907_cc0c3e99a7_o.png",
      priceColor: "white",
      description: "Exclusive to Hong Kong",
      tips: [],
      spice: 3,
      country: hongKong,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 49,
      name: "Nissin Cup Japan - Curry",
      price: 6.5,
      mobileWidth: 80,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54270042384_80c90e3c0b_o.png",
      priceColor: "beige",
      description: "Sumptuous curry noodle with potato flakes",
      tips: [],
      spice: 3,
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 50,
      name: "Ghost Pepper",
      price: 5.5,
      mobileWidth: 80,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54269797636_31b00e41d9_o.png",
      priceColor: "white",
      description:
        "Springy black noodles, a dash of sweet tempering endless waves of pain",
      tips: [],
      spice: 9,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 51,
      name: "Jjajangmen",
      price: 5.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54330624467_eda72f5f69_o.png",
      priceColor: "white",
      description: "Black bean sauce Korean noodles",
      tips: [],
      spice: "",
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: 1,
    },
    {
      number: 52,
      name: "Bibim Men Noodles",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 85,
      href: "https://live.staticflickr.com/65535/54308694686_103b82a6f4_o.png",
      priceColor: "black",
      description: "Tangy Gochujang-ketchup dry noodles, typically enjoyed cold by icing noodles after cooking",
      tips: [],
      spice: 2,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 53,
      name: "Bibim Men II Noodles",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 85,
      href: "https://live.staticflickr.com/65535/54308694651_f269b035cd_o.png",
      priceColor: "black",
      description: "Version 2 of the classic tangy Gochujang-ketchup dry noodles. Enjoy it hot or cold!",
      tips: [],
      spice: 2,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 54,
      name: "Bibim Men Spicy Noodles",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 85,
      href: "https://live.staticflickr.com/65535/54307818402_f678be0dda_o.png",
      priceColor: "black",
      description: "Ultra spicy tangy gochujang-ketchup dry noodles",
      tips: [],
      spice: 5,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 55,
      name: "Shin Ramyun",
      price: 4.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54270039768_49f835db1d_o.png",
      priceColor: "black",
      description: "The OG spicy beef broth",
      tips: [],
      spice: 4,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 56,
      name: "Shin Ramyun Black",
      price: 5.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270039773_17d4ff39cd_o.png",
      priceColor: "white",
      description: "Shin 2.0 - silky layered broth",
      tips: [],
      spice: 4,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    }, {
    number: 57,
    name: "Shin Ramyun Gold",
    price: 5.5,
    mobileWidth: 110,
    mobileHeight: 95,
    href: "https://live.staticflickr.com/65535/54268914942_c98c199103_o.png",
    priceColor: "white",
    description: "Shin with rich chicken broth instead of the classic beef - rich yet silky with complex layers of flavor",
    tips: [],
    spice: 4,
    country: korea,
    stirfry: "",
    tonkotsu: "",
    cheese: "",
    spicy: 1,
    riceNoodles: "",
    vegan: "",
    vegetarian: "",
    seafood: "",
    chicken: 1,
    beef: "",
    miso: "",
    soy: "",
    vegetable: "",
    jjajang: "",
  },
    {
      number: 58,
      name: "Shin Green",
      price: 6.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54269797721_ba30506b81_o.png",
      priceColor: "beige",
      description:
        "Silky and spicy vegan shin ramyun with mushroom and tofu flavors",
      tips: [],
      spice: 3,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 59,
      name: "Chapagetti",
      price: 4.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/53877552149_876ea4d10c_b.jpg",
      priceColor: "black",
      description: "Black bean sauce Korean noodles",
      tips: [],
      spice: "",
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: 1,
    },
    {
      number: 60,
      name: "Neoguri",
      price: 4.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/53873842627_6f2b335c3a_b.jpg",
      priceColor: "black",
      description: "Spicy seafood soup with udon-style noodles",
      tips: [],
      spice: 3,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 61,
      name: "Angry Neoguri",
      price: 4.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54330624457_3f888dac11_o.png",
      priceColor: "black",
      description: "3x Spicy Neoguri from Korea",
      tips: [],
      spice: 5,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 62,
      name: "Kimchi Ramen",
      price: 5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54308694706_3c58dda7b9_o.png",
      priceColor: "white",
      description: "For the Kimchi lovers - like Shin but more flavorful",
      tips: [],
      spice: 3,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 63,
      name: "Soon Veggie",
      price: 4.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54308694696_79ff4cd0a4_o.png",
      priceColor: "black",
      description: "Shin Ramyun but 100% Vegan/No MSG",
      tips: [],
      spice: 2,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 64,
      name: "Jjamppong",
      price: 5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54331531741_9f4faac2a0_o.png",
      priceColor: "white",
      description: "Slightly spicy classic korean seafood stew",
      tips: [],
      spice: 2,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    // {
    //   number: 56,
    //   name: "BaiXiang Chicken",
    //   price: 4.5,
    //   mobileWidth: 80,
    //   mobileHeight: 75,
    //   href: "https://live.staticflickr.com/65535/53866173945_1585f48944_m.jpg",
    //   priceColor: "black",
    //   description: "Thick Chinese ramen in a clear chicken broth",
    //   spice: "",
    //   country: china,
    //   stirfry: "",
    //   tonkotsu: "",
    //   cheese: "",
    //   spicy: "",
    //   riceNoodles: "",
    //   vegan: "",
    //   vegetarian: "",
    //   seafood: "",
    //   chicken: 1,
    //   miso: "",
    //   soy: "",
    //   vegetable: "",
    //   jjajang: "",
    // },
    // {
    //   number: 57,
    //   name: "BaiXiang Spicy Beef",
    //   price: 4.5,
    //   mobileWidth: 80,
    //   mobileHeight: 75,
    //   href: "https://live.staticflickr.com/65535/53865760266_43e15d9162_m.jpg",
    //   priceColor: "black",
    //   description: "Thick Chinese ramen deep, spicy beef soup",
    //   spice: 2,
    //   country: china,
    //   stirfry: "",
    //   tonkotsu: "",
    //   cheese: "",
    //   spicy: 1,
    //   riceNoodles: "",
    //   vegan: "",
    //   vegetarian: "",
    //   seafood: "",
    //   chicken: "",
    //   beef: 1,
    //   miso: "",
    //   soy: "",
    //   vegetable: "",
    //   jjajang: "",
    // },
    {
      number: 65,
      name: "Kokomen",
      price: 4.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54331770014_678f25cf78_o.png",
      priceColor: "black",
      description: "Rich chicken broth with a kick",
      tips: [],
      spice: 3,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    // {
    //   number: 59,
    //   name: "BaiXiang Pork Bone",
    //   price: 4.5,
    //   mobileWidth: 80,
    //   href: "https://live.staticflickr.com/65535/53866172795_3b65ce5605_m.jpg",
    //   priceColor: "black",
    //   description: "Thick Chinese ramen in a creamy pork bone broth",
    //   spice: "",
    //   country: china,
    //   stirfry: "",
    //   tonkotsu: 1,
    //   cheese: "",
    //   spicy: "",
    //   riceNoodles: "",
    //   vegan: "",
    //   vegetarian: "",
    //   seafood: "",
    //   chicken: "",
    //   miso: "",
    //   soy: "",
    //   vegetable: "",
    //   jjajang: "",
    // },
    {
      number: 66,
      name: "Ansungtangmen",
      price: 4,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54331936960_1c9c6f40f7_o.png",
      priceColor: "black",
      description: "Countryside Korean miso noodle soup",
      tips: [],
      spice: "",
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 67,
      name: "Kangshifu Braised Beef",
      price: 4.5,
      mobileWidth: 105,
      mobileHeight: 90,
      href: "https://live.staticflickr.com/65535/54308989128_a726351c59_o.png",
      priceColor: "black",
      description: "Slightly spicy braised beef soup with thick noodles",
      tips: [],
      spice: 2,
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 68,
      name: "Kangshifu Hot and Spicy Beef",
      price: 4.5,
      mobileWidth: 105,
      mobileHeight: 90,
      href: "https://live.staticflickr.com/65535/54308975364_123b45e5e0_o.png",
      priceColor: "black",
      description: "Spicy braised beef soup with thick noodles",
      tips: [],
      spice: 5,
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 69,
      name: "Kangshifu Chicken",
      price: 4.5,
      mobileWidth: 105,
      mobileHeight: 90,
      href: "https://live.staticflickr.com/65535/54307864252_8720ddc014_o.png",
      priceColor: "black",
      description: "Flavorful chicken and mushroom broth with thick noodles",
      tips: [],
      spice: "",
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 70,
      name: "Kangshifu Seafood",
      price: 4.5,
      mobileWidth: 105,
      mobileHeight: 90,
      href: "https://live.staticflickr.com/65535/54308975369_b2b2fd8b21_o.png",
      priceColor: "black",
      description: "Rich seafood soup with thick noodles",
      tips: [],
      spice: 1,
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      beef: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 71,
      name: "Kangshifu Beef with Pickled Vegetables",
      price: 4.5,
      mobileWidth: 105,
      mobileHeight: 90,
      href: "https://live.staticflickr.com/65535/54309167795_032509b68f_o.png",
      priceColor: "black",
      description: "Slightly spicy braised beef soup with tangy pickled veggies, alongside the classic kangshifu thick noodles",
      tips: [],
      spice: 2,
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 72,
      name: "Kangshifu Soyed Beef",
      price: 4.5,
      mobileWidth: 105,
      mobileHeight: 90,
      href: "https://live.staticflickr.com/65535/54308989113_f6d07fa57f_o.png",
      priceColor: "black",
      description: "Rich soy braised beef soup with thick noodles",
      tips: [],
      spice: 0,
      country: china,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      beef: 1,
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 73,
      name: "Buldak Lite",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270042364_ae669c47f9_o.png",
      priceColor: "black",
      description: "The Original Fire Noodle - but half the spice!",
      tips: [],
      spice: 4,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 74,
      name: "Buldak",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54268914812_c6453e7e34_o.png",
      priceColor: "black",
      description: "The Original Fire Noodle Challenge",
      tips: [],
      spice: 6,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 75,
      name: "Buldak JjaJang",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270219085_d982732b6a_o.png",
      priceColor: "black",
      description: "JjaJangmen on fire - extremely hot",
      tips: [],
      spice: 7,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: 1,
    },
    {
      number: 76,
      name: "Buldak Habanero Lime",
      price: 5.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54269797546_0a29056fe6_o.png",
      priceColor: "white",
      description: "Sweet citrus to cut through the heat",
      tips: [],
      spice: 6.5,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 77,
      name: "Buldak Curry",
      price: 5.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: buldakCurry,
      priceColor: "white",
      description: "Umami-Curry Buldak with plenty of kick",
      tips: [],
      spice: 6.5,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 78,
      name: "Buldak Kimchi",
      price: 5.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54268914742_d14e40bdc6_o.png",
      priceColor: "white",
      description: "Kimchi sauce for depth and serious heat",
      tips: [],
      spice: 7,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 79,
      name: "Buldak Champong",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: buldakJjamppong,
      priceColor: "black",
      description: "Hearty seafood stew to warm you up",
      tips: [],
      spice: 7,
      country: korea,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 80,
      name: "Buldak 2x",
      price: 5.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54336726452_de485c4e21_o.png",
      priceColor: "white",
      description: "Double the spice, for those who need to feel something.",
      tips: [],
      spice: 8,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 81,
      name: "Buldak 3x",
      price: 6.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54268914862_f2cce6de15_o.png",
      priceColor: "beige",
      description: "13,200 Scoville, eat at your own risk. Do not touch eyes",
      tips: [],
      spice: 10,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 82,
      name: "Buldak Carbo",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270219090_311c815bfe_o.png",
      priceColor: "black",
      description: "Cheesy Buldak that takes just a bit of the edge off",
      tips: [],
      spice: 5.5,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: 1,
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 83,
      name: "Buldak Cream Carbo",
      price: 4.5,
      mobileWidth: 110,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54270039598_c4fa84e242_o.png",
      priceColor: "black",
      description: "Creamy and cheesy, but still very spicy",
      tips: [],
      spice: 5.5,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: 1,
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 84,
      name: "Buldak Quattro Cheese",
      price: 4.5,
      href: "https://live.staticflickr.com/65535/54331348671_cc68d5f9b9_o.png",
      priceColor: "black",
      description: "Buldak x Mac 'n' Cheese, American style",
      tips: [],
      spice: 5.5,
      mobileWidth: 110,
      mobileHeight: 95,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: 1,
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 85,
      name: "Ottogi Stir Fry Cheese",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54331531716_80c3dac2f3_o.png",
      priceColor: "black",
      description: "Cheesy, creamy stir noodle. Like a ramen mac and cheese",
      tips: [],
      spice: "",
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: 1,
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 86,
      name: "Ottogi Cheese Spicy Stir Fry",
      price: 4.5,
      mobileWidth: 100,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54331756538_c34b29aca7_o.png",
      priceColor: "black",
      description:
        "Spicy, cheesey stir fry. More cheese forward than buldaks! And less spicy",
      tips: [],
      spice: 4,
      country: korea,
      stirfry: 1,
      tonkotsu: "",
      cheese: 1,
      spicy: 1,
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 87,
      name: "Tseng Sichuan Pepper Pulled Noodles",
      price: 6.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54308069892_12dce0bf93_o.png",
      priceColor: "beige",
      description:
        "An unmistakeable tingling, Mala spice oil with handpulled-style chewy noodles",
      tips: [],
      spice: 3,
      country: taiwan,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 88,
      name: "Tseng Mala Sesame Pulled Noodles",
      price: 6.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54309182464_337339ca65_o.png",
      priceColor: "beige",
      description:
        "Tingling Mala spice with sesame oil and handpulled-style chewy noodles",
      tips: [],
      spice: 2,
      country: taiwan,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 89,
      name: "Tseng White Sesame Pulled Noodles",
      price: 6.5,
      mobileWidth: 90,
      mobileHeight: 105,
      href: "https://live.staticflickr.com/65535/54309182454_aa0b676b43_o.png",
      priceColor: "beige",
      description: "Milder sesame oil with handpulled-style chewy noodles",
      tips: [],
      spice: "",
      country: taiwan,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 90,
      name: "Prima Taste Laksa",
      price: 6.5,
      mobileWidth: 100,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54331285196_54eab778fd_o.png",
      priceColor: "beige",
      description:
        "Famous Malaysian coconut soup rich with many layers of spice, seafood, curry, extra thick noodles",
      tips: [],
      spice: 2,
      country: singapore,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 91,
      name: "Prima Taste Chili Crab",
      price: 6.5,
      mobileWidth: 100,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54331506549_eef553b683_o.png",
      priceColor: "beige",
      description:
        "Rich seafood soup steeped in crab flavor with extra thick noodles",
        tips: [],
        spice: 2,
      country: singapore,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: 1,
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 92,
      name: "Prima Taste Curry Lamian",
      price: 6.5,
      mobileWidth: 100,
      mobileHeight: 110,
      href: "https://live.staticflickr.com/65535/54331691215_cf739e732e_o.png",
      priceColor: "beige",
      description: "Rich curry soup with extra thick wavy noodles",
      tips: [],
      spice: 2,
      country: singapore,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 93,
      name: "Raoh - Tonkotsu",
      price: 6.5,
      mobileWidth: 90,
      mobileHeight: 100,
      href: "https://live.staticflickr.com/65535/54331691205_850642abf6_o.png",
      priceColor: "beige",
      description:
        "Extra rich and creamy - the ultimate tonkotsu, restaurant air-dried noodles",
        tips: [],
        spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: 1,
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 94,
      name: "Raoh - Miso",
      price: 6.5,
      mobileWidth: 90,
      mobileHeight: 100,
      href: "https://live.staticflickr.com/65535/54331510088_07dfcb7449_o.png",
      priceColor: "beige",
      description:
        "Savory miso that fills the palate, restaurant air-dried noodles",
        tips: [],
        spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: 1,
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 95,
      name: "Raoh - Soy",
      price: 6.5,
      mobileWidth: 90,
      mobileHeight: 100,
      href: "https://live.staticflickr.com/65535/54330379027_23a519b3e9_o.png",
      priceColor: "beige",
      description:
        "Umami soy that fills the palate, restaurant air-dried noodles",
        tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 96,
      name: "Maruchan Gold Soy Sauce",
      price: 6.5,
      mobileWidth: 95,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54330379062_c010783851_o.png",
      priceColor: "beige",
      description:
        "Umami soy that fills the palate, restaurant air-dried noodles",
        tips: [],
      spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: "",
      soy: 1,
      vegetable: "",
      jjajang: "",
    },
    {
      number: 97,
      name: "Maruchan Gold Spicy Miso",
      price: 6.5,
      mobileWidth: 95,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54331510083_fb2df7de43_o.png",
      priceColor: "beige",
      description:
        "Savory, slightly spicy miso that fills the palate, restaurant air-dried noodles",
        tips: [],
        spice: "",
      country: japan,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: "",
      vegan: "",
      vegetarian: "",
      seafood: "",
      chicken: "",
      miso: 1,
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 98,
      name: "Maggi Masala",
      price: 4.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: "https://live.staticflickr.com/65535/54308897576_d3b63c20b8_o.png",
      priceColor: "black",
      description: "Classic Maggi masala flavor",
      tips: [],
      spice: 2,
      country: india,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 99,
      name: "Maggi Spicy Masala",
      price: 4.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: "https://live.staticflickr.com/65535/54309323090_c40ecbe024_o.png",
      priceColor: "black",
      description: "Classic Maggi masala flavor with some added heat",
      tips: [],
      spice: 4,
      country: india,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 100,
      name: "Maggi Kari",
      price: 4.5,
      mobileWidth: 70,
      mobileHeight: 85,
      href: "https://live.staticflickr.com/65535/54308018752_5aea3e85fe_o.png",
      priceColor: "black",
      description:
        "Thin stir fry noodles with an unmistakable curry flavour made with a blend of 12 signature spices",
        tips: [],
        spice: 3,
      country: india,
      stirfry: 1,
      tonkotsu: "",
      cheese: "",
      spicy: 1,
      riceNoodles: "",
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: 1,
      jjajang: "",
    },
    {
      number: 101,
      name: "Savory Mystic Miso",
      price: 7.5,
      mobileWidth: 90,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54331598224_fd9bdde010_o.png",
      priceColor: "gold",
      description:
        "Shaman Raman's miso is a soy-free chickpea miso base that resembles a traditional Japanese miso paste. A bold & creamy taste made with Non-Fortified Nutritional Yeast, Roasted Garlic, Kale, Turmeric, Black Pepper, Sea Salt, 5 powerful Adaptogenic Mushrooms + Moringa—the Miracle Leaf—are carefully alchemized together to give it a depth of flavor without weighing you down.",
        tips: [],
        spice: 0,
      country: us,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: 1,
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 102,
      name: "Spicy Cosmo Coconut",
      price: 7.5,
      mobileWidth: 90,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54331598219_0b42f2b0c1_o.png",
      priceColor: "gold",
      description:
        "Shaman Raman has created the perfect blend of a rich-tasting broth made with coconut to give it a nice creamy texture highlighted by a spicy sweetness! This combination was created with the intention to focus on brain power, packed with so many amazing ingredients including: Lion’s Mane, Sea Salt, Non-Fortified Nutritional Yeast, Pumpkin, Roasted Garlic, Red Bell Pepper, Butternut Squash, Ginger, Turmeric, & Cayenne!",
        tips: [],
        spice: 0,
      country: us,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
    {
      number: 103,
      name: "Sacred Soothing Chik'n",
      price: 7.5,
      mobileWidth: 90,
      mobileHeight: 95,
      href: "https://live.staticflickr.com/65535/54331783815_5ccfb9a7c5_o.png",
      priceColor: "gold",
      description:
        'Shaman Raman\'s take on "Chicken Noodle Soup"! Created with the intention to focus on a healthy Adaptogenic Superfood "Chik\'n" flavored instant ramen!',
        tips: [],
        spice: 0,
      country: us,
      stirfry: "",
      tonkotsu: "",
      cheese: "",
      spicy: "",
      riceNoodles: 1,
      vegan: 1,
      vegetarian: 1,
      seafood: "",
      chicken: "",
      miso: "",
      soy: "",
      vegetable: "",
      jjajang: "",
    },
  ];
  export default noodles;